var _g, _g2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 49.9999C38.8073 49.9999 50.0002 38.8071 50.0002 24.9999C50.0002 11.1928 38.8073 -6.10352e-05 25.0002 -6.10352e-05C11.1931 -6.10352e-05 0.000183105 11.1928 0.000183105 24.9999C0.000183105 38.8071 11.1931 49.9999 25.0002 49.9999Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0033 27.1614V27.1583C27.8314 27.1708 26.9455 27.2239 24.9689 27.2239C23.3908 27.2239 22.2799 27.177 21.8892 27.1583V27.163C15.8142 26.8958 11.2799 25.838 11.2799 24.5723C11.2799 23.3083 15.8142 22.2505 21.8892 21.9786V26.1098C22.2861 26.138 23.4236 26.2051 24.9955 26.2051C26.8814 26.2051 27.8267 26.127 28.0033 26.1114V21.9817C34.0658 22.252 38.5892 23.3098 38.5892 24.5723C38.5892 25.838 34.0658 26.8926 28.0033 27.1614ZM28.0033 21.552V17.8552H36.4627V12.2177H13.4299V17.8552H21.8892V21.5505C15.0142 21.8661 9.84393 23.2286 9.84393 24.8598C9.84393 26.4911 15.0142 27.852 21.8892 28.1692V40.0161H28.0033V28.1661C34.8674 27.8505 40.0252 26.4895 40.0252 24.8598C40.0252 23.2302 34.8674 21.8692 28.0033 21.552Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50012 14.9999C11.6423 14.9999 15.0001 11.642 15.0001 7.49988C15.0001 3.35774 11.6423 -0.00012207 7.50012 -0.00012207C3.35799 -0.00012207 0.00012207 3.35774 0.00012207 7.49988C0.00012207 11.642 3.35799 14.9999 7.50012 14.9999Z",
    fill: "#EF0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2806 4.64667L3.51562 3.40167L7.07578 12.3604L12.0366 6.31636L10.2806 4.64667ZM10.1719 5.19511L11.2069 6.17902L8.37656 6.69136L10.1719 5.19511ZM7.76156 6.5887L4.77844 4.11464L9.65438 5.01183L7.76156 6.5887ZM7.54922 7.02652L7.06266 11.0484L4.44 4.44699L7.54922 7.02605V7.02652ZM7.99922 7.2398L11.1337 6.67261L7.53844 11.0521L7.99922 7.2398Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15_198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.941cb9d5e891d627de274b1f3bf35eb2.svg";
export { ForwardRef as ReactComponent };